import {
  Component,
  input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabsContentGenericDetails } from '../../../../../shared/models/tabs-content-generic-details';
import { InsuranceClaimDetailsStatusHistoriesComponent } from '../insurance-claim-details-tab/insurance-claim-details-status-histories/insurance-claim-details-status-histories.component';
import { InsuranceClaimModel } from '../../../../../shared/store/insurance-claim/types';
import { InsuranceClaimDetailsAccountMovesComponent } from '../insurance-claim-details-tab/insurance-claim-details-account-moves/insurance-claim-details-account-moves.component';

@Component({
  selector: 'app-insurance-claim-tabs-details',
  templateUrl: './insurance-claim-tabs-details.component.html',
  styleUrl: './insurance-claim-tabs-details.component.scss',
  standalone: false,
})
export class InsuranceClaimTabsDetailsComponent implements OnInit, OnChanges {
  readonly insuranceClaim = input.required<InsuranceClaimModel>();

  active = 0;
  currentActive: number = 0;

  tabsContent$: BehaviorSubject<TabsContentGenericDetails[]> =
    new BehaviorSubject<TabsContentGenericDetails[]>([]);

  tabsInit: TabsContentGenericDetails[] = [
    {
      title: 'INSURANCE_CLAIM_TABS_FEES',
      component: InsuranceClaimDetailsAccountMovesComponent,
      index: 1,
      name: 'accountMoves',
    },
    {
      title: 'INSURANCE_CLAIM_TABS_STATUS_HISTORY',
      component: InsuranceClaimDetailsStatusHistoriesComponent,
      index: 2,
      name: 'statusHistories',
    },
  ];

  ngOnInit(): void {
    this.tabsContent$.next(this.tabsInit);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Keep the tab the user is on when the claim is refreshed (0 = documents, the default).
    this.active = this.currentActive;

    this.tabsContent$.next(this.tabsInit);
  }

  onActiveIdChangeSaveCurrent(active: number) {
    this.currentActive = active;
  }
}
